import AdvanceInTheWorksScreen from 'features/advance/screens/advanceStatusScreens/AdvanceInTheWorks/AdvanceInTheWorksScreen';
import React from 'react';

const AdvanceInTheWorksPage = () => {
  return <AdvanceInTheWorksScreen />;
};

export default AdvanceInTheWorksPage;
